/**
 * These permissions represent what a user is allowed to do with a profile.
 * The profile can be their own, or another users.
 * IMPORTANT: permission keys should be unique across all permission files.
 */
export default {
  EDIT_PROFILE: 'edit_profile',
  VIEW_PUBLIC_PROFILE: 'view_public_profile',
  VIEW_PROTECTED_PROFILE: 'view_protected_profile',
  VIEW_PRIVATE_PROFILE: 'view_private_profile',
  VIEW_FULL_NAME: 'view_full_name',
  CAN_BACK: 'can_back',
  CAN_PROPOSE: 'can_propose',
  CAN_INVEST: 'can_invest',
  CAN_MEET: 'engage_meet_button',
  REPORT_USER: 'report_user',
  BLOCK_USER: 'block_user',
  UNBLOCK_USER: 'unblock_user',
  CAN_POST_TO_PROFILE: 'can_post_to_profile',
};
